import {ErrorMessage} from 'formik';
import React from 'react';
import styled from 'styled-components';
import {CheckboxLabel, RadioLabel, selectSetup} from '../../../shared-components/forms/formSelectSetup';
import {FormErrorMessage} from '../form-features/FormErrorMessage';
import {FormGroup} from '../form-features/form-group/FormGroup';
import {FormLabel} from '../form-features/labels/FormLabel';

export const ClickableFormStructure = ({htmlFor, label, name, children}) => (
    <FormGroup>
        {label && <FormLabel htmlFor={htmlFor}>{label}</FormLabel>}
        {children}
        <ErrorMessage name={name} component={FormErrorMessage} />
    </FormGroup>
);

export const ClickableFormOption = ({children, htmlFor, radio, checkbox, checked, level, label, disabled}) => (
    <ClickableOptionWrapper disabled={disabled} level={level} checked={checked}>
        {children}
        {radio && (
            <RadioLabel disabled={disabled} htmlFor={htmlFor}>
                {label}
            </RadioLabel>
        )}
        {checkbox && (
            <CheckboxLabel disabled={disabled} htmlFor={htmlFor}>
                {label}
            </CheckboxLabel>
        )}
    </ClickableOptionWrapper>
);

export const ClickableOptionWrapper = styled.div`
    input {
        width: 0;
        height: 0;
        opacity: 0;
        margin: 0;
        padding: 0;
    }
    ${selectSetup()}

    ${({level}) => {
        if (level) {
            return `
                margin-left: 20px;
            `;
        } else {
            return ``;
        }
    }}
    ${({disabled}) => {
        if (disabled) {
            return `
                ${RadioLabel},
                ${RadioLabel}:hover,
                ${CheckboxLabel},
                ${CheckboxLabel}:hover {
                    color: var(--container-text-color-disabled-100);
                    opacity: 0.7;
                }
            `;
        } else {
            return ``;
        }
    }}
`;
